import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import SmsComp from './SmsComp'
import './dash.css'

function TheSMS() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <SmsComp/>      
        </div>
    </div>
  )
}

export default TheSMS